import React from 'react';

import { mapError } from 'component/Form/mapError';
import { WrappedFieldProps } from 'redux-form';
import { Autocomplete } from '@mui/material';

import { BaseTextField, BaseTextFieldProps } from './BaseTextField';

type AutocompleteOption = { name: string; id: number | string };

export type TypeheadSelectFieldProps = WrappedFieldProps & {
  autocompleteOptions: AutocompleteOption[];
} & BaseTextFieldProps;

export const TypeheadSelectField: React.FC<TypeheadSelectFieldProps> = (props) => {
  const { input, autocompleteOptions, meta, label, disabled, ...restProps } = props;
  const { onChange } = input;

  const { errorText } = mapError(meta, 'errorText');

  const options = (autocompleteOptions ?? []).map((option, index) => ({
    ...option,
    _index: index,
  }));

  const selectedOption = input.value
    ? (options.find((option) => option.id === input.value) ?? null)
    : null;

  return (
    <Autocomplete
      data-testid="autocomplete"
      disableClearable
      disabled={disabled}
      value={selectedOption}
      options={options}
      getOptionLabel={(option) => option?.name ?? ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      filterOptions={(opts, { inputValue }) => {
        const searchTerm = inputValue.toLowerCase();
        return opts.filter((opt) => opt.name?.toLowerCase().includes(searchTerm));
      }}
      onChange={(_event, newValue) => {
        onChange(newValue ? newValue.id : null);
      }}
      renderOption={(_optionProps, option) => (
        <li {..._optionProps} key={`${option.id}-${option._index}`}>
          {option.name}
        </li>
      )}
      fullWidth
      renderInput={(params) => (
        <BaseTextField
          {...restProps}
          {...params}
          inputProps={{ ...params.inputProps, ...restProps.inputProps }}
          error={!!errorText}
          helperText={errorText}
          fullWidth
          label={label}
        />
      )}
    />
  );
};
